import { lazy } from 'react'
import lazyLoad from './LazyLoad'
import { Link } from 'react-router-dom'

// const Navigation = ()=>{
//   return (
//     <>
//       <div>
//         <Link to="/index">Page1</Link>
//         <Link to="/index/page1">Page2</Link>
//       </div>
//     </>
//   )
// }

// my
export const myRouter = [
  {
    element: lazyLoad(lazy(() => import('@/pages/my/myGoodCard'))),
    path: '/my/good-card',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/my/index'))),
    path: '/my/index',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/my/myOrders'))),
    path: '/my/my-orders',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/my/address/list'))),
    path: '/my/address/list',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/my/address/edit'))),
    path: '/my/address/edit',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/my/languageSwitch'))),
    path: '/languageSwitch',
  }
  //
  // ,
  // {
  //   path: "/index",
  //   element: <Navigation />,
  //   children: [
  //     {
  //       path: '',
  //       element: lazyLoad(lazy(() => import('@/pages/home/index'))),
  //     },
  //     {
  //       path: 'page1',
  //       element: lazyLoad(lazy(() => import('@/pages/my/index'))),
  //     }
  //   ]
  // }
]